export const useAirtable = (category, url) => {
  const headers = {
    Authorization:
      "Bearer patT6ETwldmLGHKMY.bbca842bec2676eb8eb84b4010e5a3bd1e7a09da937c024c0e891d77c1729f35",
    // "Bearer pat2XA03ijjwQvzBJ.08df8da13db76f3414dc7baf09bb18d614ecf0df89c48b7fe7190fa8ba16d22a",
    "Content-Type": "application/json",
  };
  // "patT6ETwldmLGHKMY.bbca842bec2676eb8eb84b4010e5a3bd1e7a09da937c024c0e891d77c1729f35"

  const getTableId = () => {
    if (url !== "records") {
      switch (category) {
        case "group":
          return "tblKhlnd5DCTrdoSj";
        case "individual":
          return "tbl5wq4Q71dAWzVm6";
        case "club":
          return "tblmu7xeeuyp91IaW";
        default:
          throw new Error("Invalid category");
      }
    } else if (url === "records") {
      switch (category) {
        case "group":
          return "tblktVwdu6PBoehEs";
        // return "tbl3iJjhym40EPZto";
        case "individual":
          return "tbl5wq4Q71dAWzVm6";
        // return "tblOleRUbhsZcaDb2";
        case "club":
          return "tblbDNzmiJh4KDecH";
        // return "tblUsBmqmZwt0eW1D";
        default:
          throw new Error("Invalid category");
      }
    }
  };

  async function fetchData(formula = "") {
    let data = {};
    if (formula) {
      data.filterByFormula = formula;
    }
    const tableId = getTableId();

    let url =
      "https://api.airtable.com/v0/appgfFWLAtavFThZ8/" +
      // "https://api.airtable.com/v0/appZ4tJPEJpUVuZO4/" +
      tableId +
      "/listRecords";

    return await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw new Error(`Error ${response.status}: ${err.error.message}`);
          });
        }
        return response.json();
      })
      .then((data) => {
        if (!data.records || !data.records.length) {
          return { fields: null, id: 0 };
        }
        // console.log("fields: ", data.records[0].fields);
        return { fields: data.records[0].fields, id: data.records[0].id };
      })
      .catch((error) => {
        console.error("Error:", error);
        throw error;
      });
  }

  const getParticipantTableId = (category) => {
    switch (category) {
      case "clubParticipant":
        return "tblbDNzmiJh4KDecH";
      // return "tblUsBmqmZwt0eW1D";
      case "groupParticipant":
        return "tblktVwdu6PBoehEs";
      // return "tbl3iJjhym40EPZto";
      default:
        throw new Error("Invalid category");
    }
  };

  async function fetchParticipantData(category, recordId) {
    // let data = {};
    // if (formula) {
    //   data.filterByFormula = formula;

    // }

    const tableId = getParticipantTableId(category);

    let url =
      "https://api.airtable.com/v0/appgfFWLAtavFThZ8/" +
      // "https://api.airtable.com/v0/appZ4tJPEJpUVuZO4/" +
      tableId +
      "/" +
      recordId;

    console.log(url, "url", "----------");

    return await fetch(url, {
      method: "GET",
      headers: headers,
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw new Error(`Error ${response.status}: ${err.error.message}`);
          });
        }
        return response.json();
      })
      .then((data) => {
        if (!data.records || !data.records.length) {
          // throw new Error("No records found");
        }
        // Return only fields of the first record
        console.log("fields: ", data);
        return { fields: data.fields, id: data.id };
      })
      .catch((error) => {
        console.error("Error:", error);
        throw error;
      });
  }

  async function updateParticipantData(category, recordId, dataState) {
    const tableId = getParticipantTableId(category);

    let url = `https://api.airtable.com/v0/appgfFWLAtavFThZ8/${tableId}/${recordId}`;
    // let url = `https://api.airtable.com/v0/appZ4tJPEJpUVuZO4/${tableId}/${recordId}`;

    // Set up headers and data for the request

    const data = {
      fields: dataState,
    };
    console.log("dataState", dataState);

    // Make the PATCH request
    return await fetch(url, {
      method: "PATCH",
      headers: headers,
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw new Error(`Error ${response.status}: ${err.error.message}`);
          });
        }
        return response.json();
      })
      .then((data) => {
        console.log("Update successful:", data);
        return data;
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        throw error;
      });
  }

  async function updateData(recordId, dataState) {
    const tableId = getTableId();
    let url = `https://api.airtable.com/v0/appgfFWLAtavFThZ8/${tableId}/${recordId}`;
    // let url = `https://api.airtable.com/v0/appZ4tJPEJpUVuZO4/${tableId}/${recordId}`;

    console.log("dataState: ", dataState);
    // Set up headers and data for the request

    const data = {
      fields: dataState,
    };

    // Make the PATCH request
    return await fetch(url, {
      method: "PATCH",
      headers: headers,
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw new Error(`Error ${response.status}: ${err.error.message}`);
          });
        }
        return response.json();
      })
      .then((data) => {
        console.log("Update successful:", data);
        return data;
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        throw error;
      });
  }

  async function createData(dataState) {
    const tableId = getTableId();
    const url = `https://api.airtable.com/v0/appgfFWLAtavFThZ8/${tableId}`;
    // const url = `https://api.airtable.com/v0/appZ4tJPEJpUVuZO4/${tableId}`;

    // Step 3: Shape the Data
    const data = {
      records: [
        {
          fields: dataState,
        },
      ],
    };

    // Step 4: Make the Fetch Call
    return await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    })
      .then((response) => {
        // console.log("response.ok: ", response.ok);
        if (!response.ok) {
          return response.json().then((err) => {
            // console.log("err: ", err);
            throw new Error(`Error ${response.status}: ${err.error.message}`);
          });
        }
        return response.json();
      })
      .then((data) => {
        if (!data.records || !data.records.length) {
          throw new Error("No records found");
        }
        console.log("Created record: ", data.records[0]);
        return data.records[0];
      })
      .catch((error) => {
        console.error(error);
        throw error;
      });
  }

  async function createParticipantData(category, dataState) {
    const tableId = getParticipantTableId(category);
    const url = `https://api.airtable.com/v0/appgfFWLAtavFThZ8/${tableId}`;
    // const url = `https://api.airtable.com/v0/appZ4tJPEJpUVuZO4/${tableId}`;

    // Step 3: Shape the Data
    const data = {
      records: [
        {
          fields: dataState,
        },
      ],
    };

    // Step 4: Make the Fetch Call
    return await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw new Error(`Error ${response.status}: ${err.error.message}`);
          });
        }
        return response.json();
      })
      .then((data) => {
        if (!data.records || !data.records.length) {
          throw new Error("No records found");
        }
        console.log("Created record: ", data.records[0]);
        return data.records[0];
      })
      .catch((error) => {
        console.error(error);
        throw error;
      });
  }

  return {
    fetchData,
    updateData,
    createData,
    fetchParticipantData,
    updateParticipantData,
    createParticipantData,
  };
};
